<template>
  <div class="main">
    <div class="wrapper">
      <div class="downinfo">
        <div class="title">下载客户端</div>
        <div class="desc1" v-if="FileListArea1.length > 0">
          无需提前准备，一键上课与创作
        </div>
        <div class="desc1" v-else>(暂无数据)</div>
      </div>
      <div class="area1">
        <el-card class="card" shadow="hover" v-for="item of FileListArea1" :key="item.id">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="area-1">
                <div class="area-img">
                  <el-image class="tool_img" :src="item.cover_url" fit="fill"></el-image>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="area-2">
                <div class="info1">
                  <span class="title">{{ item.title }}</span>
                </div>
                <div class="info2">
                  <span class="content">{{ item.content }}</span>
                </div>
              </div>
            </el-col>
            <div v-if="item.file_one_qrcode_url === ''">
              <el-col :span="10">
                <div class="area-3">
                  <div class="btn">
                    <el-popover placement="left" width="300" trigger="click">
                      <div style="
                      padding: 5px;
                      margin-bottom: 20px;
                      text-align: center;
                    " v-for="(list, index) of JSON.parse(item.file_one_arr)" :key="index">
                        <div>
                          <div style="width: 140px; float: left">
                            {{ list.title }}
                          </div>
                          <div style="width: 140px; float: left">
                            <el-link :href="list.url" target="_blank" type="primary">下载</el-link>
                          </div>
                        </div>
                      </div>

                      <el-button slot="reference" plain>{{ item.file_one_title }}
                      </el-button>
                    </el-popover>
                    <div class="desc">{{ item.file_one_content }}</div>
                  </div>
                </div>
              </el-col>
              <el-col :span="10">
                <div class="area-4">
                  <div class="btn">
                    <el-popover placement="left" width="300" trigger="click" v-if="JSON.parse(item.file_two_arr).length > 0">
                      <div style="
                      padding: 5px;
                      margin-bottom: 20px;
                      text-align: center;
                    " v-for="(list, index) of JSON.parse(item.file_two_arr)" :key="index">
                        <div>
                          <div style="width: 140px; float: left">
                            {{ list.title }}
                          </div>
                          <div style="width: 140px; float: left">
                            <el-link :href="list.url" target="_blank" type="primary">下载</el-link>
                          </div>
                        </div>
                      </div>

                      <el-button slot="reference" plain>{{ item.file_two_title }}
                      </el-button>
                    </el-popover>
                  </div>
                </div>

              </el-col>
            </div>
            <el-col :span="12" v-else class="images">
              <div class="image" style="float:left">
                <div class="imageW">
                  <img :src="item.file_one_qrcode_url" class="imgPic" fit="fill" />
                </div>
              </div>
              <div class="txt" style="float:left;width: 25%;">
                <p>{{item.file_one_title}}</p>
                <span>{{item.file_one_content}}</span>
              </div>
              <div class="image" style="float:left">
                <div class="imageW">
                  <img :src="item.file_two_qrcode_url" class="imgPic" fit="fill" />
                </div>
              </div>
              <div class="txt" style="float:left;width: 25%;">
                <p>{{item.file_two_title}}</p>
                <span>{{item.file_two_content}}</span>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>

      <div class="downinfo1" v-if="FileListArea2.length > 0">
        <div class="title1">其他软件下载</div>
      </div>

      <div class="area2" v-if="FileListArea2.length > 0">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="helper">
              <el-card shadow="hover" v-for="item of FileListArea2" :key="item.id" style="margin-bottom:10px;">
                <div class="helper_wrapper">
                  <el-row :gutter="20">
                    <el-col :span="6">
                      <div class="area-1">
                        <div class="area-img">
                          <el-image class="tool_img" :src="item.cover_url" fit="fill"></el-image>
                        </div>
                      </div>
                    </el-col>

                    <el-col :span="6">
                      <div class="helper-left">
                        <div class="title" style="margin-left:0px">
                          <span>{{ item.title }}</span>
                        </div>
                        <div class="desc" style="margin-left:0px">
                          <span>{{ item.content }}</span>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="5">
                      <div class="helper-right">
                        <div class="btn btn1">
                          <!-- <el-popover placement="left" width="300" trigger="click">
                          <div style="
                              padding: 5px;
                              margin-bottom: 20px;
                              text-align: center;
                            " v-for="(list, index) of JSON.parse(
                              item.file_one_arr
                            )" :key="index">
                            <div>
                              <div style="width: 140px; float: left">
                                {{ list.title }}
                              </div>
                              <div style="width: 140px; float: left">
                                <el-link :href="list.url" target="_blank" type="primary">下载</el-link>
                              </div>
                            </div>
                          </div> -->

                          <el-button slot="reference" plain size="mini">
                            <span v-for="(list, index) of JSON.parse(
                              item.file_one_arr
                            )" :key="index">
                              <el-link :href="list.url" target="_blank" type="primary" style="color:#333;text-decoration: none;border-bottom: none">Windows 版 本 下 载</el-link>
                            </span>

                          </el-button>
                          <!-- </el-popover> -->
                          <div class="desc">{{ item.file_one_content }}</div>
                        </div>
                      </div>
                    </el-col>

                    <el-col :span="5">
                      <div class="helper-right btn1">
                        <!-- <el-popover placement="left" width="300" trigger="click" v-if="JSON.parse(item.file_two_arr).length > 0">
                        <div style="
                            padding: 5px;
                            margin-bottom: 20px;
                            text-align: center;
                          " v-for="(list, index) of JSON.parse(item.file_two_arr)" :key="index">
                          <div>
                            <div style="width: 140px; float: left">
                              {{ list.title }}
                            </div>
                            <div style="width: 140px; float: left">
                              <el-link :href="list.url" target="_blank" type="primary">下载</el-link>
                            </div>
                          </div>
                        </div> -->

                        <el-button slot="reference" plain size="mini" v-for="(list, index) of JSON.parse(item.file_two_arr)" :key="index"><span>
                            <el-link :href="list.url" target="_blank" type="primary" style="color:#333;text-decoration: none;border-bottom: none"> Mac 版 本 下 载</el-link>

                          </span>
                        </el-button>

                        <!-- </el-popover> -->
                        <div class="desc">{{ item.file_two_content }}</div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getSchoolFileList } from "@/api/educational";

export default {
  name: "download",

  data() {
    return {
      FileListArea1: [],
      FileListArea2: [],
      activeNames: ["1"],
    };
  },

  mounted() {
    document.getElementById("home_top").style.display = "block";
    document.getElementById("home_bottom").style.display = "none";
    this.getSchoolFileList();
  },

  methods: {
    getSchoolFileList() {
      getSchoolFileList().then((res) => {
        console.log("校区文件列表");
        console.log(res);

        this.FileList = res.schoolFileList;
        this.FileListArea1 = [];
        this.FileListArea2 = [];

        for (let k = 0; k < res.schoolFileList.length; k++) {
          if (res.schoolFileList[k].area == "1") {
            this.FileListArea1.push(res.schoolFileList[k]);
          } else if (res.schoolFileList[k].area == "2") {
            this.FileListArea2.push(res.schoolFileList[k]);
          }
        }
      });
    },
    Download(cmd, item) {
      console.log("item");
      console.log(item);

      if (cmd == "1") {
        this.$message.success("请下载附件1");
      } else if (cmd == "2") {
        this.$message.success("请下载附件2");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  background-color: #f1f7fe;
}
.wrapper {
  padding-top: 80px;
  width: 1200px;
  margin: 0 auto;
  min-height: calc(100vh - 60px);

  .downinfo {
    text-align: center;
    .title {
      font-family: PingFang SC, Lantinghei SC, Helvetica Neue, Microsoft Yahei,
        Hiragino Sans GB, Microsoft Sans Serif, WenQuanYi Micro Hei, sans,
        Helvetica, Arial, sans-serif, Roboto;
      font-size: 36px;
      font-weight: bold;
      color: #253858;
    }
    .desc1 {
      font-size: 20px;
      font-weight: 400;
      line-height: 20px;
      margin-top: 20px;
      color: #253858;
    }
  }
  .area1 {
    margin-top: 20px;
    padding: 40px;

    .card {
      margin-bottom: 20px;
      .area-1 {
        .area-img {
          margin-left: 20%;
          margin-top: 5%;
          width: 100px;
          height: 100px;
          .tool_img {
            width: 100%;
          }
        }
      }
      .area-2 {
        .info1 {
          margin-top: 25px;
          .title {
            font-size: 28px;
            font-weight: bold;
          }
        }
        .info2 {
          .content {
            margin-top: 10px;
            font-size: 14px;
            font-weight: 400;
          }
        }
      }

      .area-3 {
        text-align: center;
        .btn {
          margin-top: 40px;
        }
        .desc {
          margin-top: 10px;
        }
        .link {
          margin-top: 10px;
        }
      }

      .area-4 {
        text-align: center;
        .btn {
          margin-top: 40px;
        }
        .desc {
          margin-top: 10px;
        }
      }
    }
  }
  .downinfo1 {
    margin-top: 40px;
    text-align: center;
    .title1 {
      font-family: PingFang SC, Lantinghei SC, Helvetica Neue, Microsoft Yahei,
        Hiragino Sans GB, Microsoft Sans Serif, WenQuanYi Micro Hei, sans,
        Helvetica, Arial, sans-serif, Roboto;
      font-size: 48px;
      font-weight: bold;
      color: #253858;
    }
  }
  .area2 {
    margin-top: 20px;
    padding: 40px;
    .helper {
      .label {
        font-size: 20px;
      }
      .helper_wrapper {
        margin-top: 20px;

        .area-img {
          margin-left: 25%;
          width: 50px;
          height: 50px;
          .tool_img {
            width: 100%;
          }
        }

        .helper-left {
          .title {
            margin-left: 20px;
            font-size: 16px;
            font-weight: bold;
          }
          .desc {
            margin-left: 20px;
            font-size: 14px;
          }
        }
        .helper-right {
          text-align: center;
          .desc {
            margin-top: 10px;
          }
        }
      }
    }
    .other_tools {
      .label {
        font-size: 20px;
      }
    }
  }
}
.imageW {
  width: 100%;
}

.imgPic {
  width: 120px;
  height: 120px;
  display: block;
  margin: 0 auto;
}
.txt {
  height: 100%;
  margin-top: 40px;
  text-align: center;
}
.txt p {
  font-size: 14px;
  font-weight: bold;
}

.images .image {
  width: 25%;
}
.btn1 ::v-deep .el-link.is-underline:hover:after {
  border-bottom: 1px solid #fff;
}
</style>
